import { INCLUDE_IN_EMAIL, INCLUDE_IN_REPORTING, USER_DEFINED_DESCRIPTION, USER_DEFINED_EMAIL_DESCRIPTION } from '../../threePsCodes.constants';
import { IThreePsCodeItem } from '../../threePsCodes.model';
import type { RowFieldErrors } from './threePsCodeTable.types';

export const getRowErrors = (row: IThreePsCodeItem): RowFieldErrors => {
    const errors: RowFieldErrors = {};

    if (row[INCLUDE_IN_EMAIL] && !row[USER_DEFINED_EMAIL_DESCRIPTION]?.trim()) {
        errors.emailDescHasError = true;
    }
    if (row[INCLUDE_IN_REPORTING] && !row[USER_DEFINED_DESCRIPTION]?.trim()) {
        errors.portalDescHasError = true
    }

    return errors;
};